import { apiFetch } from './apiFetch';

const userService = {
  async getUsers(visorRef, groupId) {
    const url = `${process.env.REACT_APP_API_URL}/User/GetUserDeviceInformation?visorref=${encodeURIComponent(
      visorRef
    )}&groupId=${encodeURIComponent(groupId)}`;

    const response = await apiFetch(url, { method: 'GET' });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

async resetPassword(payload) {
  const url = `${process.env.REACT_APP_API_URL}/User/ResetPassword`;

  const response = await apiFetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    credentials: 'include',
  });

  const body = await response.json().catch(() => null);

  if (!response.ok) {
    const err = new Error(body?.message || `HTTP ${response.status}`);
    err.status = response.status;
    err.body = body;
    throw err;
  }

  return {
    isSuccess: body?.isSuccess === true,
    message: body?.message || '',
    data: body?.data ?? null,
    errors: body?.errors ?? [],
  };
},

  async resetPasswordAdmin(payload) {
    const url = `${process.env.REACT_APP_API_URL}/User/ResetPasswordAdmin`;

    const response = await apiFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'include',
    });

    const body = await response.json().catch(() => null);

    if (!response.ok) {
      const err = new Error(body?.message || `HTTP ${response.status}`);
      err.status = response.status;
      err.body = body;
      throw err;
    }

    return body;
  },

  async resetPnc(pnc, visorRef) {
    const url = `${process.env.REACT_APP_API_URL}/User/ResetPnc?pnc=${encodeURIComponent(
      pnc
    )}&visorRef=${encodeURIComponent(visorRef)}`;

    const response = await apiFetch(url, { method: 'POST' });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  async getUserList(searchQuery = '', groupId = '') {
    const url = `${process.env.REACT_APP_API_URL}/User/GetUserList?nameSearchPhrase=${encodeURIComponent(
      searchQuery
    )}&groupId=${encodeURIComponent(groupId)}`;

    const response = await apiFetch(url, { method: 'GET' });

    if (!response.ok) {
      throw new Error(`User not found`);
    }

    return await response.json();
  },

  async getAnalystsList(searchQuery = '') {
    const url = `${process.env.REACT_APP_API_URL}/User/GetAnalystsNames?nameSearchPhrase=${encodeURIComponent(
      searchQuery
    )}`;

    const response = await apiFetch(url, { method: 'GET' });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  async createMobileUser(payload) {
    const url = `${process.env.REACT_APP_API_URL}/User/CreateMobileUser`;

    const response = await apiFetch(url, {
      method: 'POST',
      credentials: 'include',
      logoutOnUnauthorized: false,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const body = await response.json().catch(() => null);

    if (!response.ok) {
      const err = new Error(body?.message || `HTTP ${response.status}`);
      err.status = response.status;
      err.body = body;
      throw err;
    }

    return body;
  },

  async createPCUser(payload) {
    const url = `${process.env.REACT_APP_API_URL}/User/CreateInstallAccount`;

    const response = await apiFetch(url, {
      method: 'POST',
      credentials: 'include',
      logoutOnUnauthorized: false,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const body = await response.json().catch(() => null);

    if (!response.ok) {
      const err = new Error(body?.message || `HTTP ${response.status}`);
      err.status = response.status;
      err.body = body;
      throw err;
    }

    return body;
  },

  async bulkCreateMobileUsers(payload) {
    const url = `${process.env.REACT_APP_API_URL}/User/BulkCreateMobileUsers`;

    const response = await apiFetch(url, {
      method: 'POST',
      credentials: 'include',
      logoutOnUnauthorized: false,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const body = await response.json().catch(() => null);

    if (!response.ok) {
      const err = new Error(body?.message || `HTTP ${response.status}`);
      err.status = response.status;
      err.body = body;
      throw err;
    }

    return body;
  },

  async deleteMobileUserAccount(username) {
    const url = `${process.env.REACT_APP_API_URL}/User/DeleteMobileUser?username=${encodeURIComponent(username)}`;
    const response = await apiFetch(url, {
      method: 'DELETE',
      credentials: 'include',
    });

    if (!response.ok) {
      const body = await response.json().catch(() => null);
      const err = new Error(body?.message || `HTTP ${response.status}`);
      err.status = response.status;
      err.body = body;
      throw err;
    }

    return { isSuccess: true };
  },

  async deletePCInstallAccount(username) {
    const url = `${process.env.REACT_APP_API_URL}/User/DeletePcUser?username=${encodeURIComponent(username)}`;
    const response = await apiFetch(url, {
      method: 'DELETE',
      credentials: 'include',
    });

    if (!response.ok) {
      const body = await response.json().catch(() => null);
      const err = new Error(body?.message || `HTTP ${response.status}`);
      err.status = response.status;
      err.body = body;
      throw err;
    }

    return { isSuccess: true };
  }
};

userService.getMobileUser = async (username) => {
  const url = `${process.env.REACT_APP_API_URL}/User/GetMobileUser?username=${encodeURIComponent(
    username
  )}`;

  const response = await apiFetch(url, { method: 'GET' });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};
//get install user
userService.getPoliceUser = async (username) => {
  const url = `${process.env.REACT_APP_API_URL}/User/GetPoliceUser?username=${encodeURIComponent(
    username
  )}`;

  const response = await apiFetch(url, { method: 'GET' });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

//get install user
userService.getInstallAccountNames = async (username) => {
  const url = `${process.env.REACT_APP_API_URL}/User/GetInstallAccountNames?nameSearchPhrase=${encodeURIComponent(
    username
  )}`;

  const response = await apiFetch(url, { method: 'GET' });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

userService.updateMobileUser = async (payload) => {
    const url = `${process.env.REACT_APP_API_URL}/User/UpdateMobileUserAccount`;

    const response = await apiFetch(url, {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const body = await response.json().catch(() => null);

    if (!response.ok) {
      const err = new Error(body?.message || `HTTP ${response.status}`);
      err.status = response.status;
      err.body = body;
      throw err;
    }
    return body;
  };

userService.updatePCInstallAccount = async (payload) => {
    const url = `${process.env.REACT_APP_API_URL}/User/UpdatePcUserInstallAccount`;

    const response = await apiFetch(url, {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const body = await response.json().catch(() => null);

    if (!response.ok) {
      const err = new Error(body?.message || `HTTP ${response.status}`);
      err.status = response.status;
      err.body = body;
      throw err;
    }
    return body;
  };



export default userService;
